import { Checkbox, Col, Divider, Drawer, Row, Typography } from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo } from "../../../../context";

const SetPermission = ({ open, close, setLoading, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  // const [loadings, setLoadings] = useState(false);

  // const [employeePermission, setEmployeePermission] = useState({
  //   data: [],
  //   ready: false,
  // });

  const [acknowledge, setAcknowledge] = useState(false);
  const [disable, setDisable] = useState(false);

  const onChange = (e, permission) => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.employee_user_id);
    formdata.append("method", e.target.checked ? "create" : "delete");
    formdata.append("permission", permission);

    // setLoadings(true);
    setDisable(true);
    axios
      .post("user/commissary/update-or-create/permission", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif(
            "success",
            e.target.checked
              ? "Created permission successfully."
              : "Deleted permission successfully."
          );
          setTimeout(() => {
            setDisable(false);
            // setLoadings(false);
            setLoading(false);
            getEmployeePermission();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoadings(false);
      });
  };

  const getEmployeePermission = useCallback(() => {
    var params = { user_id: selectedData.employee_user_id };
    axios
      .get("user/commissary/get/spec-employee-permission", { params })
      .then((response) => {
        const data = response.data;
        setAcknowledge(
          data.find(({ permission }) => permission === "acknowledge")
            ? true
            : false
        );
        // setEmployeePermission({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [selectedData.employee_user_id]);

  useEffect(() => {
    getEmployeePermission();
  }, [getEmployeePermission]);

  return (
    <Drawer
      title="Set Permission"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Delivery
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "acknowledge")}
            checked={acknowledge}
            disabled={disable}
          >
            Acknowdge & Process PO
          </Checkbox>
        </Col>
      </Row>
      <Divider />
    </Drawer>
  );
};

export default SetPermission;
